export default __webpack_public_path__ + "static/media/CurriculumDocument.af4fa9f6.svg";